import { render, staticRenderFns } from "./warn-info-import-list.vue?vue&type=template&id=06df43c6&scoped=true"
import script from "./warn-info-import-list.vue?vue&type=script&lang=ts"
export * from "./warn-info-import-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df43c6",
  null
  
)

export default component.exports